import React from 'react';
import { Routes } from 'services/route';

export const chatRoutes: Routes = [
  {
    path: '',
    component: React.lazy(() => import('pages/chat')),
  },
  {
    path: ':conversationId',
    component: React.lazy(() => import('pages/chat/pages/chat-private')),
  },
  {
    path: 'mini-chat',
    component: React.lazy(() => import('pages/chat/mini-chat')),
  },
  // {
  //   path: 'max-chat',
  //   component: React.lazy(() => import('pages/chat/max-chat')),
  // },
  {
    path: 'model',
    component: React.lazy(() => import('pages/chat/create-model')),
  },
];
